export const STATE_PROP_NAME = 'industriesPage'
